import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
} from "reactstrap";

const ModalReport = ({
  isModalOpen,
  toggleModal,
  handleSubmit,
  setSelectedOptions,
}) => {
  const options = [
    { image: "/COPO.jpg", label: "COPO MIS" },
    { image: "/Goaml.jpg", label: "CIB" },
    { image: "/Goaml.jpg", label: "GO-AML" },
    { image: "/NEFSCUN.jpg", label: "NEFSCUN" },
    { image: "/DistrictCoop.jpg", label: "District COOP Reporting" },
    {
      image: "/DistrictCoop.jpg",
      label: "Municipality Cooperative Department",
    },
    { image: "/DistrictCoop.jpg", label: "Provincial Cooperative Department" },
  ];

  return (
    <Modal isOpen={isModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal} className="text-center"></ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <p>
                <strong>Select affiliated organization to submit report</strong>
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            {options.map((option, index) => (
              <Col xs={6} md={3} key={index} className="text-center mb-3">
                <div
                  className="position-relative image-container px-auto border rounded"
                  style={{ borderWidth: "3px", height: "100%" }}
                >
                  <div className=" form-check form-check-success mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`image${index + 1}`}
                      onChange={() => handleCheckboxChange(index)}
                      defaultChecked
                    />
                    <label
                      className="form-check-label mb-3"
                      htmlFor={`image${index + 1}`}
                    ></label>
                  </div>

                  <div className="img-container mt-2">
                    <img
                      src={option.image}
                      className="img-fluid rounded"
                      alt={`Option ${index + 1}`}
                      style={{
                        width: "50%",
                        height: "auto",
                        margin: "auto",
                      }}
                    />
                    <div className="text-below-image mt-2 px-2">
                      <p>{option.label}</p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <Row className="d-flex justify-content-center mt-2">
            <Col>
              <div className="d-flex justify-content-center">
                {/* {["submitted", "approved"].includes(reportStatus) && ( */}
                <Button className="btn btn-info waves btn-submit-report w-50">
                  Submit report
                </Button>
                {/* )} */}
              </div>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};
export default ModalReport;

// import React from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   Container,
//   Row,
//   Col,
//   Button,
// } from "reactstrap";

// const ModalReport = ({
//   isModalOpen,
//   toggleModal,
//   handleSubmit,
//   setSelectedOptions,
//   handleSaveDraft,
//   status,
// }) => {
//   const options = [
//     { image: "/COPO.jpg", label: "COPO MIS" },
//     { image: "/Goaml.jpg", label: "CIB" },
//     { image: "/Goaml.jpg", label: "GO-AML" },
//     { image: "/NEFSCUN.jpg", label: "NEFSCUN" },
//     { image: "/DistrictCoop.jpg", label: "District COOP Reporting" },
//     {
//       image: "/DistrictCoop.jpg",
//       label: "Municipality Cooperative Department",
//     },
//     { image: "/DistrictCoop.jpg", label: "Provincial Cooperative Department" },
//   ];

//   const handleCheckboxChange = (index) => {
//     setSelectedOptions((prevOptions) => {
//       const newOptions = [...prevOptions];
//       if (newOptions.includes(index)) {
//         newOptions.splice(newOptions.indexOf(index), 1);
//       } else {
//         newOptions.push(index);
//       }
//       return newOptions;
//     });
//   };

//   return (
//     <Modal isOpen={isModalOpen} toggle={toggleModal}>
//       <ModalHeader toggle={toggleModal} className="text-center"></ModalHeader>
//       <ModalBody>
//         <Container>
//           <Row>
//             <Col lg={12} className="text-center">
//               <p>
//                 <strong>Select affiliated organization to submit report</strong>
//               </p>
//             </Col>
//           </Row>
//           <Row className="justify-content-center mt-2">
//             {options.map((option, index) => (
//               <Col xs={6} md={3} key={index} className="text-center mb-3">
//                 <div
//                   className="position-relative image-container px-auto border rounded"
//                   style={{ borderWidth: "3px", height: "100%" }}
//                 >
//                   <div className="form-check form-check-success mt-2">
//                     <input
//                       className="form-check-input"
//                       type="checkbox"
//                       id={`image${index + 1}`}
//                       onChange={() => handleCheckboxChange(index)}
//                     />
//                     <label
//                       className="form-check-label mb-3"
//                       htmlFor={`image${index + 1}`}
//                     ></label>
//                   </div>
//                   <div className="img-container mt-2">
//                     <img
//                       src={option.image}
//                       className="img-fluid rounded"
//                       alt={`Option ${index + 1}`}
//                       style={{
//                         width: "50%",
//                         height: "auto",
//                         margin: "auto",
//                       }}
//                     />
//                     <div className="text-below-image mt-2 px-2">
//                       <p>{option.label}</p>
//                     </div>
//                   </div>
//                 </div>
//               </Col>
//             ))}
//           </Row>

//           <Row className="d-flex justify-content-center mt-2">
//             <Col>
//               <div className="d-flex justify-content-center">
//                 {status === "Draft" && (
//                   <Button
//                     className="btn btn-info waves btn-submit-report w-50"
//                     type="submit"
//                     // onClick={handleSaveDraft}
//                   >
//                     Submit report
//                   </Button>
//                 )}
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </ModalBody>
//     </Modal>
//   );
// };

// export default ModalReport;
